module.exports = __webpack_public_path__ + "img/lunbo221.ee489bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo221.png
// module id = /VOh
// module chunks = 0